import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { getLightColorForHour } from '../utils/dayNightColors';

const DynamicLighting = ({ currentHour, ambientIntensity }) => {
  const ambientRef = useRef();
  const directionalRef = useRef();

  const getColorForHour = (hour) => {
    return new THREE.Color(getLightColorForHour(hour));
  };

  useFrame(() => {
    const hour = currentHour % 24;
    const targetColor = getColorForHour(hour);
    const smoothingFactor = 0.05; // Valore tra 0 e 1 per controllare la fluidità

    if (ambientRef.current) {
      // Interpolazione fluida del colore
      ambientRef.current.color.lerp(targetColor, smoothingFactor);
      // Interpolazione fluida dell'intensità
      ambientRef.current.intensity = THREE.MathUtils.lerp(ambientRef.current.intensity, ambientIntensity, smoothingFactor);
    }
    if (directionalRef.current) {
      directionalRef.current.color.lerp(targetColor, smoothingFactor);
    }
  });

  return (
    <>
      <ambientLight ref={ambientRef} intensity={ambientIntensity} />
      <directionalLight
        ref={directionalRef}
        castShadow
        position={[5, 15, 10]}
        intensity={1.5}
        shadow-mapSize-width={1024}
        shadow-mapSize-height={1024}
        shadow-camera-near={1}
        shadow-camera-far={50}
        shadow-camera-left={-10}
        shadow-camera-right={10}
        shadow-camera-top={10}
        shadow-camera-bottom={-10}
      />
    </>
  );
};

export default DynamicLighting;
